import React, { useState, useRef, useEffect } from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import "./App.css";
import HomeContainer from "./containers/HomeContainer";
import ResumeContainer from "./containers/ResumeContainer";
import AboutContainer from "./containers/AboutContainer";
import ContactContainer from "./containers/ContactContainer";
import NotFound from "./components/NotFound";
import ProjectsContainer from "./containers/ProjectsContainer";
import countapi from "countapi-js";

function App() {
  const [forceUpdate, setForceUpdate] = useState(false);
  const counter = useRef(null);

  useEffect(() => {
    countapi
      .hit("ishaansharma.netlify.app", "ishaansharma")
      .then(
        (result) =>
          (counter.current.innerText = parseInt(result.value).toLocaleString())
      );
  }, []);

  function forceUpdateTrue() {
    setForceUpdate(true);
  }

  function forceUpdateFalse() {
    setForceUpdate(false);
  }

  return (
    <div id="homepage">
      <div id="navbar">
        <NavLink to="/" exact activeClassName="" className="navbar-links">
          <img src={require("./media/logo.png").default} alt="logo" id="logo" />
        </NavLink>
        <div className="counter floating" ref={counter}>
          0
        </div>
        <NavLink
          to="/contact"
          exact
          activeClassName="active"
          className="navbar-links"
        >
          05. Contact
        </NavLink>
        <NavLink
          to="/about"
          exact
          activeClassName="active"
          className="navbar-links"
        >
          04. About
        </NavLink>
        <NavLink
          to="/resume"
          exact
          activeClassName="active"
          className="navbar-links"
          onClick={forceUpdateTrue}
        >
          03. Resume
        </NavLink>
        <NavLink
          to="/projects"
          exact
          activeClassName="active"
          className="navbar-links"
          onClick={forceUpdateTrue}
        >
          02. Projects
        </NavLink>
        <NavLink to="/" exact activeClassName="active" className="navbar-links">
          01. Home
        </NavLink>
      </div>

      <div id="social-links-div">
        <a
          href="https://github.com/Ishaan-11"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            src={require("./media/github-icon.svg").default}
            alt="github-icon"
            className="icons"
          />
        </a>
        <br></br>
        <a
          href="https://www.linkedin.com/in/ishaan11"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            src={require("./media/linkedin-icon.svg").default}
            alt="linkedin-icon"
            className="icons"
          />
        </a>
        <br></br>
        <a href={`mailto:ishaansharma1998@gmail.com`}>
          <img
            src={require("./media/send.png").default}
            alt="send-img"
            className="icons"
          />
        </a>
      </div>

      <Switch>
        <Route exact path="/" render={() => <HomeContainer />} />
        <Route
          exact
          path="/projects"
          render={() => (
            <ProjectsContainer
              forceUpdate={forceUpdate}
              forceUpdateFalse={forceUpdateFalse}
            />
          )}
        />
        <Route
          exact
          path="/resume"
          render={() => (
            <ResumeContainer
              forceUpdate={forceUpdate}
              forceUpdateFalse={forceUpdateFalse}
            />
          )}
        />
        <Route exact path="/about" render={() => <AboutContainer />} />
        <Route exact path="/contact" render={() => <ContactContainer />} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
